// Base URL
export const BASE_URL = process.env.REACT_APP_API_URL;

// Statuses
export const STATUSES = Object.freeze({
  IDLE: 'idle',
  ERROR: 'error',
  LOADING: 'loading'
});
